import React, { useEffect } from 'react';
import { useStatsig } from '../hooks/useStatsig';

const StatsigRouteSwitch = ({ gate, enabledTo, Component, routeProps }) => {
  const { checkGate } = useStatsig();
  const isEnabled = checkGate(gate);

  useEffect(() => {
    if (isEnabled && enabledTo) {
      // Always external
      window.location.href = enabledTo;
    }
  }, [isEnabled, enabledTo]);

  if (isEnabled) {
    return null;
  }

  // FF OFF → render legacy component
  return <Component {...routeProps} />;
};

export default StatsigRouteSwitch;
